import React from 'react';
import ReactDOM from 'react-dom';

export default class UIStatusDialog extends React.Component {
  constructor(props) {
    super(props);

    this.dispatchCompletion = this.dispatchCompletion.bind(this);
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this).addEventListener('animationend', this.dispatchCompletion, false);
  }

  dispatchCompletion(e) {
    if (this.props.closeDialog) {
      this.props.closeDialog(
        this.props,
        !Utils.isNotDefined(this.props.closeDialogProps) ? this.props.closeDialogProps : null,
      );
    }
  }

  render() {
    let status;
    let message;
    let title;
    if (this.props.status) {
      status = `status-box ${this.props.status.status ? this.props.status.status : 'hide'}`;
      message = this.props.status.message;
      title = this.props.status.title;
    }
    return (
      <div className={status}>
        <h4>{title}</h4>
        <div>{message}</div>
      </div>
    );
  }
}
